import React, {useEffect, useRef, useState} from "react";

import {Card, CardBody, Col, Container, Input, Row} from "reactstrap";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar} from "antd";
import HospitalSearch from "../hospital/HospitalSearch";
import Swal from "sweetalert2";
import ImportModal from "../import/ImportModal";
import Select from "react-select";
import ApiService from "../util/ApiService";
import Skeleton from "react-loading-skeleton";
import ScaleModal from "../dashboard/calender/scaleModal";
import UsersSearch from "../dashboard/calender/UsersSearch";

import CustomPagination from "../util/CustomPagination";
import ScalePostingSelectedModal from "./ScalePostingSelectedModal";
import AuthService from "../login/AuthService";
import {format, parseISO} from 'date-fns';
import {ptBR} from 'date-fns/locale';
import {Tooltip} from 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DutyMigrateUserModal from "./ScaleMigrateUserModal";
import ScaleMigrateUserModal from "./ScaleMigrateUserModal";

const ScaleRegisterPage = () => {
    document.title = "Escala Padrão Registro | Plantão Rápido";

    const user = AuthService.getUserData();
    const refHospitalSearch = useRef(null);

    const [selectedIds, setSelectedIds] = useState([]);
    const refUserSearch = useRef(null);

    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [selectedScale, setSelectedScale] = useState(null);
    const [showSelectedMigrateModal, setShowSelectedMigrateModal] = useState(null);
    const [arrayScaleSelected, setArrayScaleSelected] = useState(null);
    const [showScaleModal, setShowScaleModal] = useState(false);
    const [showSelectedModal, setShowSelectedModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});


    const [filters, setFilters] = useState({
        dateRange: [],
        datestart: null,
        dateend: null,
        user_id: "",
        hospital: "",
        duty_scale_day_wee_id: "",
        order_month: "",
        department_id: "",
    });


    const [importModalVisible, setImportModalVisible] = useState(false);
    const [importType, setImportType] = useState(null);
    const [arraScale, setArrayScale] = useState([]);

    const handleImportClick = () => {
        setImportType(3); // Tipo 1 para Escala
        setImportModalVisible(true);
    };

    const handleScaleModalClose = (save = false) => {
        setShowScaleModal(false);
        setSelectedScale(null); // Limpar o plantão selecionado
        if (save) {
            fetchArray(pagination.current, false, false);
        }

    };
    const handleScaleModalMigrateClose = (save = false) => {

        setSelectedScale(null); // Limpar o plantão selecionado
        setShowSelectedMigrateModal(false);
        fetchArray(pagination.current, false, false);

    };


    useEffect(() => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach((tooltipTriggerEl) => {
            new Tooltip(tooltipTriggerEl, {container: 'body'});
        });
    }, [arraScale]);


    const handleModalOpen = (scale) => {
        setSelectedScale(scale); // Define o plantão selecionado
        setShowScaleModal(true); // Abre o modal
    };


    const handleNewButtonClick = () => {
        setShowScaleModal(true);

    };


    const handleCheckboxChange = (id) => {
        setSelectedIds((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((itemId) => itemId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };


    const fetchArray = async (page, isExport = false, isClear = false) => {
        if (!isExport) {
            setLoading(true);
        }
        if (isClear) {
            setSelectedIds([]);
        }


        try {
            const responseType = isExport ? "blob" : "json";

            const params = {
                pagination: pagination.pageSize,
                page: page,
                date_start: filters.datestart ? filters.datestart : null,
                date_end: filters.dateend ? filters.dateend : null,
                order_month: filters.order_month !== undefined && filters.order_month !== null ? filters.order_month : null,
                duty_scale_day_wee_id: filters.duty_scale_day_wee_id ? filters.duty_scale_day_wee_id : null,
                hospital_id: filters?.hospital_id ? filters?.hospital_id : null,
                department_id: filters?.department_id ? filters?.department_id : null,
                user_id: filters.user_id,
                isExport: isExport,
            };

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}scale/list`,
                params,
                true,
                responseType
            );

            if (isExport) {
                // Processa exportação de arquivo
                const blob = new Blob([response], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = `export_${new Date().toISOString().split("T")[0]}.xlsx`;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            } else {
                // Atualiza a lista e paginação
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setArrayScale(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});


            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };


    const fetchArraySelect = async (filtersStatus = false, type = 'generate') => {
        setLoading(true); // inicia o loading aqui, se estiver usando

        try {
            // Parâmetros obrigatórios
            const params = {
                idArray: selectedIds,
                isAll: true
            };

            // Se filtros forem passados, adiciona os filtros no params
            if (filtersStatus) {
                params.date_start = filters.date_start || null;
                params.date_end = filters.date_end || null;
                params.order_month = filters.order_month ?? null;
                params.duty_scale_day_wee_id = filters.duty_scale_day_wee_id || null;
                params.hospital_id = filters.hospital_id || null;
                params.department_id = filters.department_id || null;
                params.user_id = filters.user_id || null;
                params.perPage = 1000;
                params.isExport = false;
                params.idArray = null;
            }


            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}scale/list`,
                params,
                true
            );
            const {data} = ApiService.handleApiResponse(response);
            const filtered = (data || []).filter(item => item.user);

            setArrayScaleSelected(filtered);

            if (filtered.length > 0) {

                if (type === 'generate') {
                    console.log(type);
                    setShowSelectedModal(true);
                } else {
                    console.log(type);
                    setShowSelectedMigrateModal(true)
                }


            } else {
                Swal.fire("Erro!", "Nenhuma escala encontrada ou escala sem usuário definido!", "error");
            }

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchDepartment();
        fetchArray(1);
    }, []);


    const fetchDepartment = async () => {
        try {
            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}departments/list-department`, {
                all: true,
                status: 'S'
            }, true);
            const {data} = ApiService.handleApiResponse(response);
            const options = data.map(department => ({
                value: department.id,
                label: department.name,
            }));
            setDepartmentOptions(options);

        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const calculateDuration = (start, totalHours) => {
        const [hours, minutes, seconds] = start.split(':').map(Number);

        // Cria um Date com hora inicial baseada no dia atual
        let startDate = new Date();
        startDate = setHours(startDate, hours);
        startDate = setMinutes(startDate, minutes);
        startDate = setSeconds(startDate, seconds);

        // Separar parte inteira e decimal das horas
        const fullHours = Math.floor(totalHours);
        const extraMinutes = Math.round((totalHours - fullHours) * 60);

        // Somar ao horário
        let endDate = addHours(startDate, fullHours);
        endDate = addMinutes(endDate, extraMinutes);

        return endDate;
    };


    const handleClearFilters = () => {
        setFilters({
            datestart: null,
            dateend: null,
            dateRange: "",
            status: "",
            hospital_id: "",
            user_id: "",
            duty_scale_day_wee_id: "",
            order_month: "",
            department_id: null, // Limpa o departamento
        });

        if (refUserSearch?.current) {
            refUserSearch?.current?.clearUser();
        }

        if (refHospitalSearch?.current) {
            refHospitalSearch?.current?.clearHospital();
        }
    };


    const statusOptions = [
        {value: "accepted", label: "Aceito"},
        {value: "pending", label: "Pendente"},
        {value: "rejected", label: "Rejeitado"},
        {value: "reenvio", label: "Reenvio"},
    ];

    const getOrderMonthText = (orderMonth) => {
        switch (orderMonth) {
            case 0:
                return "Toda Semana"; // Para o valor 0
            case 1:
                return "1ª Semana";
            case 2:
                return "2ª Semana";
            case 3:
                return "3ª Semana";
            case 4:
                return "4ª Semana";
            case 5:
                return "5ª Semana";
            default:
                return "Semana não especificada";
        }
    };


    const handleDelete = async (id) => {
        // Mostrar o modal de confirmação
        Swal.fire({
            title: "Você tem certeza?",
            text: "Esta ação não pode ser desfeita!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sim, deletar!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Realiza a requisição de exclusão
                    const response = await ApiService.send(
                        "delete",
                        `${process.env.REACT_APP_URL_API}scale/delete`,
                        {id}, // Dados enviados para o back-end
                        true // Necessário autenticação
                    );
                    if (response.code === 200) {
                        Swal.fire("Deletado!", "Registro Deletado com Sucesso", "success");
                        fetchArray(1, false); // Atualiza a lista após a exclusão
                    }
                } catch (error) {
                    ApiService.handleApiError(error);
                }
            }
        });
    };


    const handleScalePosting = () => {
        Swal.fire({
            title: "Como deseja gerar os plantões?",
            text: "Você pode gerar pelos plantões selecionados ou pelo filtro acima.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Selecionados",
            cancelButtonText: "Pelo Filtro",
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                handleScalePostingSelectedModal(); // plantões selecionados
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                fetchArraySelect(true); // pelo filtro
            }
        });
    };


    const handleScalePostingSelectedModal = () => {
        if (selectedIds.length > 0) {
            fetchArraySelect();
        } else {
            Swal.fire("Erro!", "Nenhuma escala selecionada!", "error");
        }
    }


    const handleSelectedModalClose = () => {
        setShowSelectedModal(false)
    }


    const handleMigrateUser = () => {
        Swal.fire({
            title: "Como deseja migrar as escalas?",
            text: "Você pode migrar as escalas selecionadas ou aplicar os filtros acima para definir quais migrar.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Selecionados",
            cancelButtonText: "Pelo Filtro",
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                handleDutyMigrateSelectedModal(); // migrar selecionados
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                fetchArraySelect(true, 'migrate'); // migrar pelo filtro
            }
        });
    };

    const handleDutyMigrateSelectedModal = () => {
        if (selectedIds.length > 0) {
            fetchArraySelect(false, 'migrate');
        } else {
            Swal.fire("Erro!", "Nenhuma escala selecionada!", "error");
        }
    }

    document.title = "Registro Escala | Plantão Rápido";
    return (
        <>

            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Cadastro" pageTitle="Escala Padrão"/>

                        <Row className="">

                            <div>
                                <button type="button"
                                        className="me-2 btn btn-outline-secondary"
                                        onClick={() => handleImportClick()}
                                >
                                    <i className="fa fa-upload"></i> Importar
                                </button>
                                <button type="button"
                                        className="me-2 btn btn-outline-info"
                                        onClick={() => handleNewButtonClick()}
                                >
                                    <i className="fa fa-plus"></i> Cadastrar
                                </button>


                            </div>
                            <div className="row mt-1 ">
                                <div className="col-12 col-xl-3 col-lg-3 col-md-6">
                                    <HospitalSearch
                                        ref={refHospitalSearch}
                                        buttonAdd={false}
                                        validateManager={true}
                                        cache={false}
                                        onHospitalSelect={(hospital) =>
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                hospital_id: hospital?.value || "",
                                            }))
                                        }
                                    />
                                </div>
                                <div className="col-12 col-xl-2 col-lg-2 col-md-6 form-group">
                                    <label>Ordem</label>
                                    <select
                                        className="form-control"
                                        value={filters.order_month}
                                        onChange={(e) =>
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                order_month: e.target.value,
                                            }))
                                        }
                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                            }), // Definindo z-index alto
                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                        }}
                                    >
                                        <option value="" disabled>
                                            Selecione a semana
                                        </option>
                                        <option value="0">Toda Semana</option>
                                        <option value="1">1ª Semana</option>
                                        <option value="2">2ª Semana</option>
                                        <option value="3">3ª Semana</option>
                                        <option value="4">4ª Semana</option>
                                        <option value="5">5ª Semana</option>
                                    </select>
                                </div>

                                <div className="col-12 col-xl-3 col-lg-3 col-md-6 form-group">
                                    <UsersSearch
                                        ref={refUserSearch}
                                        onUserSelect={(user) =>
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                user_id: user?.value || "",
                                            }))
                                        }
                                    />
                                </div>


                                <div className="col-6 col-xl-2 col-lg-2 col-md-6 form-group">
                                    <label>Semana</label>
                                    <select
                                        className="form-control"
                                        value={filters.duty_scale_day_wee_id}
                                        onChange={(e) =>
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                duty_scale_day_wee_id: e.target.value,
                                            }))
                                        }
                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                            }), // Definindo z-index alto
                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                        }}

                                    >
                                        <option value="" disabled>
                                            Selecionar
                                        </option>
                                        <option value="0">Domingo</option>
                                        <option value="1">Segunda-Feira</option>
                                        <option value="2">Terça-Feira</option>
                                        <option value="3">Quarta-Feira</option>
                                        <option value="4">Quinta-Feira</option>
                                        <option value="5">Sexta-Feira</option>
                                        <option value="6">Sábado</option>
                                    </select>
                                </div>


                                <div className="col-6 col-xl-2 col-lg-2 col-md-6 form-group">
                                    <label>Departamento</label>
                                    <Select
                                        isClearable={true}
                                        value={filters.department_id}
                                        onChange={(selectedOption) =>
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                department_id: selectedOption, // Atualiza ou limpa o filtro
                                            }))
                                        }
                                        options={departmentOptions}
                                        placeholder="Selecionar"
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                            }), // Definindo z-index alto
                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="row ">
                                <div className="col-md-12 d-flex justify-content-end">
                                    <button type="button" className="btn mr-1 me-2"
                                            onClick={() => handleClearFilters()}>
                                        <i className="fa fa-eraser"></i> Limpar Filtros
                                    </button>
                                    <button type="button" className="btn btn-warning btn-s mr-1 me-2"
                                            onClick={() => handleMigrateUser()}>
                                        <i className="fa fa-exchange-alt"></i> Migrar Usuário
                                    </button>
                                    <button type="button"
                                            className="mr-1 me-2 btn btn-danger"
                                            onClick={() => handleScalePosting()}
                                    >
                                        <i className="fa fa-rocket"></i> Gerar Plantão
                                    </button>
                                    <button type="button"
                                            className="mr-1 me-2 btn btn-dark"
                                            onClick={() => fetchArray(1, true)}
                                    >
                                        <i className="fa fa-download"></i> Exportar
                                    </button>

                                    <button type="button"
                                            className="mr-1 me-2 btn btn-success"
                                            disabled={loading}
                                            onClick={() => fetchArray(1, false, true)}
                                    >

                                        <i className={`fa ${loading ? "spinner-border spinner-border-sm me-2" : "fa-search"}`}></i>{" "}
                                        {loading ? "Buscando..." : "Buscar"}
                                    </button>
                                </div>
                            </div>


                        </Row>

                        <Row className="gy-2 mb-2 mt-3" id="candidate-list">

                            {loading ? (
                                <>
                                    <Card className="mb-1 p-2 shadow-sm" style={{fontSize: "12px"}}>
                                        <CardBody className="d-flex justify-content-between align-items-center p-2">

                                            {/* 🏥 Skeleton para Hospital + Localização */}
                                            <div className="d-flex align-items-center">
                                                <Skeleton circle width={40} height={40} className="me-2"/>
                                                <div>
                                                    <Skeleton width={120} height={12}/>
                                                    <Skeleton width={100} height={10}/>
                                                </div>
                                            </div>

                                            {/* 📅 Skeleton para Datas e Informações */}
                                            <div>
                                                <Skeleton width={140} height={10}/>
                                                <Skeleton width={100} height={10}/>
                                                <Skeleton width={80} height={10}/>
                                            </div>

                                            {/* 👨‍⚕️ Skeleton para Usuário e Valor */}
                                            <div className="d-flex align-items-center">
                                                <div className="text-end me-3">
                                                    <Skeleton width={60} height={15}/>
                                                    <Skeleton width={80} height={10}/>
                                                </div>
                                                <Skeleton circle width={40} height={40} className="me-2"/>
                                                <div>
                                                    <Skeleton width={100} height={12}/>
                                                    <Skeleton width={80} height={10}/>
                                                </div>
                                            </div>

                                            {/* 🔧 Skeleton para Ações */}
                                            <div className="text-end">
                                                <Skeleton width={20} height={20} className="me-1"/>
                                                <Skeleton width={20} height={20}/>
                                            </div>

                                        </CardBody>
                                    </Card>
                                </>
                            ) : (
                                arraScale?.length > 0 ? (
                                    arraScale.map((scale) => (
                                        <Col lg={12} key={scale.id}>
                                            <Card className="mb-3 p-3 shadow-sm card-hover">
                                                <CardBody className="p-0">
                                                    <Row className="align-items-center">
                                                        <Col xs={1} md={1}>
                                                            <input
                                                                type="checkbox"
                                                                className="checkbox-wrapper-23 me-3 mt-1"
                                                                checked={selectedIds.includes(scale.id)}
                                                                style={{width: '14px', height: '14px'}}
                                                                onChange={() => handleCheckboxChange(scale.id)}
                                                            />
                                                        </Col>
                                                        <Col xs={6} md={3} className="mb-3 mb-md-0">

                                                            {scale?.user ? (
                                                                <div>
                                                                    <h6 className="mb-1 d-flex align-items-center">
                                                                        <Avatar
                                                                            src={scale?.user?.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                                            className="avatar-perfect-circle me-2"
                                                                        />
                                                                        {scale?.user?.name}
                                                                    </h6>
                                                                    <p className="text-muted d-block">
                                                                        {scale?.user?.ddd && scale?.user?.phone
                                                                            ? `(${scale.user.ddd}) - ${scale.user.phone}`
                                                                            : "Telefone não informado"}
                                                                    </p>
                                                                    <p
                                                                        className="d-inline-block small px-2 py-1 rounded bg-light border text-muted"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title="Data da última geração de escala"
                                                                    >
                                                                        <i className="fa fa-info-circle me-1 text-primary"></i>
                                                                        {scale?.date_start && scale?.date_end
                                                                            ? `${format(parseISO(scale.date_start), "dd/MM/yyyy", {locale: ptBR})} - ${format(parseISO(scale.date_end), "dd/MM/yyyy", {locale: ptBR})}`
                                                                            : "Pendente gerar plantão"}
                                                                    </p>


                                                                </div>
                                                            ) : (
                                                                <span>Usuário não selecionado</span>
                                                            )}
                                                        </Col>

                                                        {/* Coluna 2: Informações do plantão */}
                                                        <Col xs={6} md={3} className="mb-3 mb-md-0">
                                                            <p className="text-success fw-bold fs-6 mb-1">
                                                                {new Intl.NumberFormat("pt-BR", {
                                                                    style: "currency",
                                                                    currency: "BRL",
                                                                }).format(scale.value)}
                                                            </p>
                                                            <p className="text-muted mb-1">
                                                                <i className="fa fa-clock text-primary me-1"></i>
                                                                {scale.time_begin?.slice(0, 5)} - {scale.time_end?.slice(0, 5)}
                                                            </p>
                                                            <p className="text-muted mb-1">
                                                                <i className="fa fa-pause text-primary me-1"></i>
                                                                {scale.lunch_time ? scale.lunch_time.slice(0, 5) : 'Sem de intervalo'}
                                                            </p>
                                                            <p className="text-muted mb-1">
                                                                <i className="fa fa-calendar-alt text-primary me-1"></i>
                                                                {getOrderMonthText(scale?.order_month)} - <small>{scale?.duty_scale_day_week?.name || "Dia não informado"}</small>
                                                            </p>
                                                            <p className="text-muted mb-1">
                                                                <i className="fa fa-hourglass-half text-primary me-1"></i>
                                                                {scale.total_hours?.slice(0, 5)} horas
                                                            </p>
                                                        </Col>

                                                        {/* Coluna 3: Usuário */}

                                                        <Col xs={12} md={3}
                                                             className="d-flex align-items-start mb-3 mb-md-0">


                                                            <Avatar
                                                                src={
                                                                    scale.hospital?.images?.[0]?.file ||
                                                                    process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"
                                                                }
                                                                size={60}
                                                                className="me-3"
                                                            />
                                                            <div>
                                                                <h6 className="fw-bold mb-1 text-break">{scale.hospital?.name || "Hospital não especificado"}</h6>
                                                                <p className="text-muted mb-0">
                                                                    <i className="fa fa-map-marker-alt text-info me-1"></i>
                                                                    {scale.hospital?.city_name || "Cidade não especificada"},{" "}
                                                                    {scale.hospital?.uf || "UF não especificada"}
                                                                </p>
                                                            </div>
                                                        </Col>


                                                        {/* Coluna 4: Ações */}
                                                        <Col xs={12} md={2} className="text-md-end text-start">
                                                            <button type="button"
                                                                    className="btn btn-sm btn-info text-white me-2 mb-2"
                                                                    onClick={() => handleModalOpen(scale)}
                                                            >
                                                                <i className="fa fa-edit me-1"></i> Editar
                                                            </button>
                                                            <button type="button"
                                                                    className="btn btn-sm btn-danger mb-2 me-2 mb-2"
                                                                    onClick={() => handleDelete(scale.id)}
                                                            >
                                                                <i className="fa fa-trash me-1"></i> Excluir
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>

                                    ))
                                ) : (
                                    <div className="alert alert-primary" role="alert">
                                        Realizar filtro de Escala.
                                    </div>
                                )
                            )}

                            <CustomPagination
                                className="mt-4"
                                pagination={pagination}
                                onChange={(page) => fetchArray(page, false)}
                            />
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
            {
                importModalVisible && (
                    <ImportModal
                        show={importModalVisible}
                        onHide={() => setImportModalVisible(false)}
                        importType={importType}
                    />
                )
            }
            {showScaleModal && (
                <ScaleModal
                    scale={selectedScale}
                    show={showScaleModal}
                    handleClose={handleScaleModalClose}
                    handleSubmit={() => {
                        setShowScaleModal(false);
                    }}
                />
            )}

            {showSelectedMigrateModal && (
                <ScaleMigrateUserModal
                    scale={selectedScale}
                    arraySelect={arrayScaleSelected}
                    show={showSelectedMigrateModal}
                    handleClose={handleScaleModalMigrateClose}
                    handleSubmit={() => {
                        setShowScaleModal(false);
                    }}
                />
            )}

            {showSelectedModal && (
                <ScalePostingSelectedModal
                    scale={selectedScale}
                    show={showSelectedModal}
                    arraySelect={arrayScaleSelected}
                    handleClose={handleSelectedModalClose}
                />
            )}
        </>
    )
        ;
};

export default ScaleRegisterPage;
